import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type ListImageClassificationsV1ExploreClassificationsGetErrors,
  type ListImageClassificationsV1ExploreClassificationsGetResponse,
  listImageClassificationsV1ExploreClassificationsGet,
} from '../../generated';

export interface ListImageClassificationsQueryVariables {
  product_category_id?: string;
}

export type ListImageClassificationsQuery = ListImageClassificationsV1ExploreClassificationsGetResponse;

export const useListImageClassificationsQuery = <
  TData = ListImageClassificationsQuery,
  TError = ListImageClassificationsV1ExploreClassificationsGetErrors[keyof ListImageClassificationsV1ExploreClassificationsGetErrors],
>(
  variables?: ListImageClassificationsQueryVariables,
  options?: Omit<UseQueryOptions<ListImageClassificationsQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<ListImageClassificationsQuery, TError, TData>({
    queryKey: ['ListImageClassifications', variables],
    queryFn: async () => {
      const { data } = await listImageClassificationsV1ExploreClassificationsGet({
        throwOnError: true,
        // Pass product_category_id as a query parameter.
        // The generated types don't include this yet — regenerate the API
        // client once the OpenAPI spec is updated to remove this cast.
        ...(variables?.product_category_id
          ? { query: { product_category_id: variables.product_category_id } as never }
          : {}),
      });
      return data;
    },
    ...options,
  });
};

useListImageClassificationsQuery.getKey = (variables?: ListImageClassificationsQueryVariables) => [
  'ListImageClassifications',
  variables,
];

useListImageClassificationsQuery.fetcher = (_headers?: RequestInit['headers']) => {
  return async () => {
    const { data } = await listImageClassificationsV1ExploreClassificationsGet({
      throwOnError: true,
    });
    return data;
  };
};
